<mat-card appearance="outlined">
  <ng-container *ngIf="!loading; else loadingSpinner">
    <div class="login-wrapper">
      <img class="logo" alt="Vendasta" src="/static/images/vendasta-logo-large.png" />

      <form #f="ngForm" (ngSubmit)="login(f)">
        <EXP__glxy-wrap>
          <mat-form-field appearance="outline" [hideRequiredMarker]="true">
            <input matInput placeholder="Email" name="email" [(ngModel)]="email" />
          </mat-form-field>
        </EXP__glxy-wrap>

        <EXP__glxy-wrap>
          <mat-form-field appearance="outline" [hideRequiredMarker]="true">
            <input matInput placeholder="Password" type="password" name="password" [(ngModel)]="password" />
          </mat-form-field>
        </EXP__glxy-wrap>

        <div class="sso-separator">
          <span class="sso-separator-or">or</span>
        </div>

        <!--Option to enter partner ID-->
        <EXP__glxy-wrap>
          <mat-form-field appearance="outline" [hideRequiredMarker]="true">
            <input matInput placeholder="Partner ID" name="partnerId" [(ngModel)]="partnerId" />
          </mat-form-field>
        </EXP__glxy-wrap>

        <!--Option to enter session token-->
        <EXP__glxy-wrap>
          <mat-form-field appearance="outline" [hideRequiredMarker]="true">
            <input matInput placeholder="Session Token" name="sessionToken" [(ngModel)]="sessionToken" />
          </mat-form-field>
        </EXP__glxy-wrap>

        <button class="login-button" type="submit" mat-raised-button color="primary">Sign In</button>
      </form>

      <div class="sso-separator">
        <span class="sso-separator-or">or</span>
      </div>

      <div class="sso-logins">
        <div class="google-sso-sign-in" (click)="loginWithGoogle()">
          <div class="google-sso-sign-in__icon"></div>
          <span class="google-sso-sign-in__text">Sign in with Google</span>
        </div>
      </div>
      <div class="local-dev-info">Local Development</div>
    </div>
  </ng-container>

  <ng-template #loadingSpinner>
    <div class="loading-spinner-wrapper">
      <mat-spinner class="loading-spinner" [diameter]="40"></mat-spinner>
      Signing in...
    </div>
  </ng-template>
</mat-card>
